import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export function Section({
  title,
  components,
  columnSpacing,
  rowSpacing,
  infoText,
  justifyContent,
  alignItems,
  textAlign,
  width = '100%',
  // When this component was created it was subject to the influence of global styles from our legacy CSS
  maxWidth = '50rem',
  sx = {},
}) {
  const theme = useTheme();

  // components must contain an array of React components/elements
  // you can set the number of columns each component spans via the sectionComponentSize prop
  const getGridItemSizeProps = (sectionComponentSize) => {
    // This function can be tweaked to support more sizes
    switch (sectionComponentSize) {
      case 'x-small':
        return {
          xs: 6,
          sm: 2,
        };
      case 'small':
        return {
          xs: 6,
          sm: 3,
        };
      case 'small-up-5':
        return {
          xs: 6,
          sm: 4,
          md: 12 / 5,
        };
      case 'small-medium-up-2-on-mobile':
        return {
          xs: 6,
          sm: 4,
        };
      case 'small-medium':
        return {
          xs: 12,
          sm: 4,
        };
      case 'medium':
        return {
          xs: 12,
          sm: 6,
        };
      case 'large':
        return {
          xs: 12,
        };
      default:
        // default to medium
        return { xs: 12, sm: 6 };
    }
  };

  const containerSx = { '& .MuiFormControl-root': { width: '100%' }, ...sx };

  return (
    <>
      <Box paddingRight={0} maxWidth={maxWidth} sx={containerSx} width={width}>
        <Grid
          container
          justifyContent={justifyContent}
          alignItems={alignItems}
          columnSpacing={columnSpacing}
          rowSpacing={rowSpacing}
          textAlign={textAlign}
        >
          {title && (
            <Grid item xs={12}>
              <Box
                component="h4"
                display="inline-block"
                color={theme.palette.primary.main}
                textAlign="left"
                textTransform="uppercase"
                marginTop={0}
              >
                {title}
              </Box>
            </Grid>
          )}
          {infoText && (
            <Grid item xs={12}>
              <Typography variant="p">{infoText}</Typography>
            </Grid>
          )}
          {components.map((component, index) => {
            const sizeProps = getGridItemSizeProps(
              /*
                lowercase version of prop, sectioncomponentsize, is checked in the event it's a plain DOM element rather
                than React component. This addresses the console warning that React isn't "recognizing" the prop
                Warning: React does not recognize the `sectionComponentSize` prop on a DOM element. If you intentionally want
                         it to appear in the DOM as a custom attribute, spell it as lowercase `sectioncomponentsize` instead.
                         If you accidentally passed it from a parent component, remove it from the DOM element.
              */
              component.props.sectionComponentSize ||
                component.props.sectioncomponentsize
            );

            return (
              <Grid item key={index} {...sizeProps}>
                {component}
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}
Section.defaultProps = {
  columnSpacing: 6,
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
  rowSpacing: 2,
  maxWidth: '50rem',
  infoText: null,
  title: null,
};
